import styles from './skeleton.module.css'
import type { SkeletonProps } from './skeleton.type'

export const Skeleton = ({ height, width = '100%', className = '' }: SkeletonProps) => {
    return (
        <div
            className={`${styles.skeleton} ${className}`.trim()}
            style={{
                height: height ? (typeof height === 'number' ? `${height}px` : height) : undefined,
                width: typeof width === 'number' ? `${width}px` : width,
            }}
        />
    )
}
